import { useEffect, useState } from "react";

export const PeriodoSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);

  // Cargar los meses del año
  const cargarArray = () => {
    return [
      { mes: "Enero", value: 1 },
      { mes: "Febrero", value: 2 },
      { mes: "Marzo", value: 3 },
      { mes: "Abril", value: 4 },
      { mes: "Mayo", value: 5 },
      { mes: "Junio", value: 6 },
      { mes: "Julio", value: 7 },
      { mes: "Agosto", value: 8 },
      { mes: "Septiembre", value: 9 },
      { mes: "Octubre", value: 10 },
      { mes: "Noviembre", value: 11 },
      { mes: "Diciembre", value: 12 }
    ];
  };

  useEffect(() => {
    setState(cargarArray());
  }, [name]);

  if (state.length === 0) return <div>No data</div>;
  return (
    <select
      className="select-ejercicio"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="0">Seleccionar...</option>
      {state.map((item) => (
        <option key={`mes-${item.value}`} value={item.value}>
          {item.mes}
        </option>
      ))}
    </select>
  );
};
